<template>
  <div class="">
    <b-modal v-model="showModal"
    id="ticket-modal"
    no-close-on-backdrop
    no-close-on-esc
    @hidden="hideModal"
    hide-footer>
      <template #modal-title>
        <strong>Új kérdés</strong>
      </template>
      <b-form-group label="Tárgy">
          <b-form-input v-model="ticket.subject"></b-form-input>
          <div
            class="validation-error-msg"
            ref="subject-validation-message"
          />
        </b-form-group>

        <b-form-group label="Üzenet">
          <b-form-textarea
            id="textarea"
            v-model="ticket.message"
            rows="3"
          ></b-form-textarea>
          <div
            class="validation-error-msg"
            ref="message-validation-message"
          />
        </b-form-group>
      <div class="d-flex justify-content-end mt-5">
          <b-button variant="secondary" :disabled="!enableButtons" @click="cancelAction">Mégse</b-button>
          <b-button variant="primary" :disabled="!enableButtons" @click="confirmAction" class="ml-2">Küldés</b-button>
      </div>

    </b-modal>
  </div>
</template>
  
<script>
import Api from "api-client/index";
import { mapGetters } from "vuex";
import Util from "@/utils/Util";

export default {
    props: {
      show: {
        type: Boolean,
        default: false
      },
    },
    data() {
      return {
        showModal: this.show,
        enableButtons: true,
        ticket: {}
      };
    },
    watch: {
      show(newVal) {
        this.showModal = newVal;
      }
    },
    computed: {
        ...mapGetters("app", ["getActiveCompany"]),
    },
    methods: {
      cancelAction() {
        this.ticket = {}
        this.showModal = false;
        this.$emit('update:show', false);
      },
      hideModal() {
        this.ticket = {}
        this.$emit('update:show', false);
      },
      confirmAction() {
        this.createTicket();
      },
      createTicket() {
        this.enableButtons = false;
        return Api.createTicket(this.ticket, this.getActiveCompany.id).then(() => {
          Util.clearValidationErrors(
            document.getElementById("ticket-modal")
          );
          this.cancelAction();
          this.$toast.success({
            title: "Sikeres kérdés!",
            message: "Kollégáink hamarosan válaszolnak!",
          });
        }).catch((err) => {
          this.$toast.error({
            title: "Sikertelen üzenetküldés",
          });
          if (err.isAxiosError && err.response.data.failList) {
            setTimeout(() => {
              Util.clearValidationErrors(
                document.getElementById("ticket-modal")
              );
              Util.showValidationErrors(err, this.$refs);
            }, 100);
          }
        }).finally(() => {
          this.enableButtons = true
        });
      }
    }
  };
</script>
<style scoped>
  input, select, textarea {
    border-radius: 32px;
    background: rgba(174, 191, 199, 0.50);
    box-shadow: 0px 20px 30px 0px rgba(0, 0, 0, 0.10);
    font-size: 12px;
    padding: 20px;
  }
</style>